import { createSelector } from 'reselect'
import { IDifferentActivitiesRecord } from './interface'

export const getDifferentActivities = (state: any): IDifferentActivitiesRecord => state.get('differentActivities')

export const getDifferentActivitiesPending = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.get('pending')
)

export const getFavoriteActivitiesLoadStatus = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.getIn(['loaded', 'favorite'])
)

export const getUpcomingActivitiesLoadStatus = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.getIn(['loaded', 'upcoming'])
)

export const getPreviousActivitiesLoadStatus = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.getIn(['loaded', 'previous'])
)

export const getFavoriteActivities = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.get('favorite')
)

export const getUpcomingActivities = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.get('upcoming')
)

export const getPreviousActivities = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.get('previous')
)
